import { render, staticRenderFns } from "./JsonInputArray.vue?vue&type=template&id=5be47aca&scoped=true&"
import script from "./JsonInputArray.vue?vue&type=script&lang=js&"
export * from "./JsonInputArray.vue?vue&type=script&lang=js&"
import style0 from "./JsonInputArray.vue?vue&type=style&index=0&id=5be47aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be47aca",
  null
  
)

export default component.exports